import React, { useCallback, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import i18n from 'i18next';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAgent from '../../../common/hooks/useAgent';
import missionAgent from '../../agents/missionAgent';
import MissionForm from '../form/MissionForm';
import { MissionExact } from '../../models/Mission';
import { Container } from '../../../common/components/layout';

const MissionReupload = ({ mission, onBackClick, onUpdatedSuccess }) => {
  const { id } = useParams();
  const [updateMission, updatedMission] = useAgent(missionAgent.updateMission);

  const handleSubmit = useCallback((values) => updateMission(id, values), [id, updateMission]);

  useEffect(() => {
    if (updatedMission) {
      toast.success(i18n.t('mission.message.updateSuccess'));
      onUpdatedSuccess(id);
    }
  }, [id, onUpdatedSuccess, updatedMission]);

  const formattedMission = useMemo(() => {
    const { missionName, ...cleanedMission } = mission;
    return { ...cleanedMission, name: missionName };
  }, [mission]);

  return (
    <Container>
      <MissionForm mission={formattedMission} onBackClick={onBackClick} onSubmit={handleSubmit} />
    </Container>
  );
};

MissionReupload.propTypes = {
  onBackClick: PropTypes.func,
  mission: MissionExact.isRequired,
  onUpdatedSuccess: PropTypes.func,
};

MissionReupload.defaultProps = {
  onBackClick: undefined,
  onUpdatedSuccess: undefined,
};
export default MissionReupload;
